import React from 'react';
import { useViewlogies } from 'context';
import { capitalizeFirst } from 'utils';

const GetStarted = ({ onNext }) => {
    const {
        event: { lastName, color },
    } = useViewlogies();

    const familyName = capitalizeFirst(lastName);
    const bullets = [
        `We talked to the ${familyName} family and they will graciously accept any care package you wish to send.`,
        `We already confirmed the address where the care package should be shipped.`,
        `We already confirmed dietary restrictions.`,
        `You pick the care package and we will ensure the ${familyName} family receives your package.`,
    ];

    return (
        <div className="care-package-get-started">
            <h3 className="care-package-section-title care-package-get-started-title" style={{ color }}>
                The days following the funeral are difficult.
            </h3>
            <ul className="care-package-bullets">
                {bullets.map((bullet, i) => (
                    <li key={i} className="care-package-bullet">
                        <span className="care-package-checkmark">&#10003;</span>
                        <span>{bullet}</span>
                    </li>
                ))}
            </ul>
            <button className="care-package-btn" style={{ backgroundColor: color }} onClick={onNext} type="button">
                Get Started
            </button>
        </div>
    );
};

export default GetStarted;
